<template>
  <div class="content-item flex">
    <div class="disease-tab-list flex">
      <span class="disease-tab disease-tab-add" @click="openDeseaseDialog"
        >添加Drug名称</span
      >
      <span
        class="disease-tab"
        v-for="(item, index) in diseaseLabels"
        :key="index"
      >
        {{ item.genericName }} {{ item.tradeName }}
        <img src="~_img/off.png" alt="del" @click="delDisease(index)" />
      </span>
    </div>
    <!-- <p>给文章打上相关的疾病，可以帮您更好的展示文章</p> -->
    <modal
      :isShow.sync="dialogDeseaseVisible"
      :title="dialogTitles"
      :btnText="btnText"
      :isShowBtn="isShowBtn"
      :width="dialogWidth"
      @clickHandler="clickHandler"
    >
      <div class="search-dialog-wrap">
        <el-input
          placeholder="请输入Drug名称"
          v-model="searchDiseaseName"
          class="input-with-select"
          maxlength="20"
          show-word-limit
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="queryDiseases"
            class="search-but"
            >搜索</el-button
          >
        </el-input>
        <div class="search-desease-body">
          <div class="search-data">
            <el-checkbox-group
              v-model="searchDiseaseChecked"
              v-if="searchDiseaseList.length && !isShowSearchNoData"
              @change="searchDiseaseChange"
            >
              <el-checkbox
                :label="item.drugId"
                v-for="(item, index) in searchDiseaseList"
                :key="index"
              >
                {{ item.genericName }} {{ item.tradeName }}
                {{ item?.specification || "" }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
          <div
            class="noData flex flex-direction-column justify-content-center align-items-center"
            v-if="isShowSearchNoData"
          >
            <img src="~_img/search-noData.png" alt="没有数据" />
            <p class="errorInfo">很抱歉，暂未收录相关药品</p>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import modal from "@/components/modal";
import { request } from "../../../../../utils/axios";

export default {
  name: "SelectEncyclopedia",
  props: ["data", "isShowEncyclopedia", "functionIds", "isQuestion"],
  data() {
    return {
      deseaseTips: false,
      dialogDeseaseVisible: false, //添加疾病弹窗
      isShowSearchNoData: false,
      searchDiseaseName: "",
      searchDiseaseList: [],
      searchDiseaseListHistory: [],
      searchDiseaseChecked: [],
      diseaseLabels: [],
      dialogTitles: "搜索Drug名称",
      btnText: ["取消", "确认"],
      dialogWidth: "480px",
      isShowBtn: [true, true],
    };
  },
  components: {
    modal,
  },
  watch: {
    data(val) {
      console.log(val, 9999000);
      this.searchDiseaseChecked = [];
      if (val) {
        for (let i = 0; i < val.length; i++) {
          this.searchDiseaseChecked.push(val[i].diseaseId);
        }
      }
      this.diseaseLabels = val;
      val.map((item) => {
        this.searchDiseaseListHistory.push(item);
      });
    },
  },
  created() {
    this.diseaseLabels = this.data;
    console.log(this.data, 9999901);
  },
  methods: {
    clickHandler(val) {
      if (val == "one") {
        this.dialogDeseaseVisible = false;
      }
      if (val == "two") {
        this.addDesease();
        this.$emit("changeEncyclopediaLabels", this.diseaseLabels);
      }
    },
    //打开药品标签弹窗
    openDeseaseDialog() {
      this.dialogDeseaseVisible = true;
      this.isShowSearchNoData = false;
      this.searchDiseaseList = [];
      this.searchDiseaseName = "";
    },
    // 获取选中的药品标签
    searchDiseaseChange() {
      // 无关联药品数量约束
      // if (this.searchDiseaseChecked && this.searchDiseaseChecked.length > 1) {
      //   this.$message.error('关联药品最多选1个~')
      //   this.searchDiseaseChecked.pop();
      // }
    },
    getSearchDiseaseListData() {
      let array = [];
      this.searchDiseaseChecked.map((i) => {
        this.searchDiseaseListHistory.map((item, index) => {
          if (i == item.drugId) {
            array.push(item);
          }
        });
      });
      let _map = [];
      return array.filter((item) => {
        if (!_map.includes(item.drugId)) {
          _map.push(item.drugId);
          return true;
        } else {
          return false;
        }
      });
    },
    //添加药品
    addDesease() {
      // 无需对添加数量进行约束
      // if (this.searchDiseaseChecked.length > 1) {
      //   return
      // }
      let dataList = this.getSearchDiseaseListData();
      this.diseaseLabels = this.diseaseLabels || [];
      this.diseaseLabels.splice(0, this.diseaseLabels.length, ...dataList);
      this.dialogDeseaseVisible = false;
    },
    delDisease(index) {
      this.diseaseLabels.splice(index, 1);
      this.searchDiseaseChecked.splice(index, 1);
    },
    // 搜索药品
    queryDiseases() {
      if (this.data) {
        this.searchDiseaseChecked = [];
        this.data.map((item) => {
          this.searchDiseaseChecked.push(item.drugId);
        });
      }
      if (this.searchDiseaseName) {
        //通过关键词获取药品
        request(this.functionIds.queryEncyclopedia, {
          tenantId: this.$commonJs.getTenantId(),
          genericName: this.searchDiseaseName,
        })
          .then((res) => {
            if (res && res.data && res.data.length) {
              this.isShowSearchNoData = false;
              this.searchDiseaseList = res.data;
              res.data.map((item) => {
                this.searchDiseaseListHistory.push(item);
              });
            } else {
              this.isShowSearchNoData = true;
            }
          })
          .catch((err) => {
            this.isShowSearchNoData = true;
          });
      } else {
        this.isShowSearchNoData = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/dialog_common.scss";

$color: #266cee;

.content-item-label {
  width: 107px;
  text-align: right;
  margin-right: 10px;
  flex-shrink: 0;
  height: 52px;

  span {
    color: #f62458;
    margin-right: 5px;
  }
}

.input-with-select {
  width: 437px !important;
  padding-bottom: 4px !important;
}

//疾病搜索
.search-dialog-wrap {
  min-height: 138px;
  margin: 20px;

  .search-data {
    max-height: 138px;
    overflow: hidden;
    overflow-y: auto;
    margin-top: 20px;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      width: 4px;
      height: 30px;
      background-color: #989ca5;
    }

    .el-checkbox {
      margin-right: 24px;
    }

    .el-checkbox__label {
      color: #262626;
      padding-left: 6px;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background: $color;
      border-color: $color;
    }

    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #262626;
    }

    .el-checkbox__inner:hover {
      border-color: $color;
    }
  }

  .noData {
    img {
      width: 121px;
      height: 78px;
      border: none;
    }

    p {
      font-size: 12px;
      color: #9a9a9a;
      margin-top: 20px;
    }
  }
}

.have {
  cursor: pointer;
}

.btns {
  padding-bottom: 22px;
  padding-top: 40px;
  line-height: 0px !important;
}

.dialog-but {
  padding-top: 9px;
}

:deep(.button) {
  line-height: 0px !important;
}

:deep(.el-button .el-button--primary) {
  padding-top: 10px;
}

.search-but {
  padding-top: 8px;
}

.errorInfo {
  width: 145px !important;
  text-align: right;
  margin-right: 10px;
}

.desease-tips {
  width: 147px !important;
  height: 20px;
  position: absolute;
  left: 878px;
  top: 0;
}

.disease-tab-add {
  width: 150px !important;
  position: absolute !important;
  left: 0px;
  top: -15px;
}

.disease-tab-list {
  padding-top: 40px;
  position: relative !important;
  display: flex;
  flex-wrap: wrap;
  .disease-tab {
    display: inline-block;
    height: 32px;
    line-height: 32px;
    text-align: center;
    // background: rgba(255, 110, 0, 0.12);
    border: 1px solid #0058ee;
    border-radius: 2px;
    padding: 0 16px;
    margin-right: 28px;
    margin-top: 10px !important;
    cursor: pointer;
    // color: #FF6E00;
    color: #0058ee;
    position: relative;
    margin-bottom: 20px;

    img {
      position: absolute;
      top: -8px;
      right: -8px;
      width: 15px;
      height: 15px;
      background-size: 15px;
    }
  }

  .disease-tab-add {
    border: 1px dashed rgba(154, 154, 154, 1);
    background: rgba(255, 255, 255, 1);
    color: rgba(38, 38, 38, 1);

    &::before {
      content: "";
      display: inline-block;
      width: 12px;
      height: 12px;
      background: url("~_img/add.png") no-repeat;
      background-size: 12px;
    }

    &::after {
      display: none;
    }
  }
}
</style>
